{#if show}
  <button 
    on:click|preventDefault|stopPropagation
    on:keypress|preventDefault|stopPropagation={onPressed}
    class="icon-button"
    style={ bcss && bcss.styled(vw) }
    tabindex="1"
    >
    <Icon { ...iprops } name={name} />
  </button>
{/if}

<style>
.icon-button {
  display: inline-block;
  box-sizing: border-box;
  margin:0;
  padding:0;
  background-color: transparent;
  border: none;
}
</style>

<svelte:window bind:innerWidth={vw} />

<script>
  import { createEventDispatcher } from 'svelte';
  import { Css } from 'svelte-stylo'
  import { Icon } from 'svelte-stylo'

  export let
    show = true,
    name = '';
    
  let 
    vw = 0,
    bcss,
    icss,
    iprops;

  let dispatch = createEventDispatcher();

  bcss = Css($$props)
          .whitelist(['m','mr','ml','mt','mb'])

  icss = Css($$props)
          .blacklist(['m','mr','ml','mt','mb'])

  iprops = icss.props()

  $: { if (vw && $$props) 
    show = icss.visible(show, vw);
  }

  function onPressed(ev) {
    if (!ev.key === 13) return;
    dispatch('click', ev);
  }
</script>
